var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot_button",class:{ border: _vm.border }},[_c('div',{staticClass:"foot_button_content"}),_c('div',{staticClass:"foot_button_content foot"},[_c('div',{staticClass:"foot_button_content__inner"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }